<template>
  <tr>
    <td>{{ companyCalendar.serviceName }}</td>
    <td>{{ externalCalendarConnection.email }}</td>
    <td>{{ targetDisplay }}</td>
    <td v-if="isSelfOwnedConnection">{{ companyCalendar.calendarName }}</td>
    <td v-else>
      <div
        class="tw-inline-flex tw-bg-blue-200 tw-rounded-full tw-text-center tw-px-5 tw-py-1"
      >
        <span class="tw-text-blue-500 tw-font-semibold"
          >Owned by another employment</span
        >
      </div>
    </td>
    <td>{{ companyCalendar.scopeNames }}</td>
    <td style="width: 300px;" class="tw-text-center">
      <template v-if="companyCalendar.status === 'disabled'">
        <div
          class="tw-inline-flex tw-bg-gray-200 tw-rounded-full tw-text-center tw-px-5 tw-py-1"
        >
          <span class="tw-text-gray-500 tw-font-semibold">Unavailable</span>
        </div>
      </template>
      <template v-else>
        <div
          v-if="companyCalendar.sync_enabled"
          class="tw-inline-flex tw-bg-green-200 tw-rounded-full tw-text-center tw-px-5 tw-py-1"
        >
          <span class="tw-text-green-500 tw-font-semibold">Connected</span>
        </div>
        <div
          v-if="
            companyCalendar.sync_enabled &&
              externalCalendarConnection.service_error
          "
          class="tw-ml-2 tw-inline-flex tw-bg-orange-200 tw-rounded-full tw-text-center tw-px-5 tw-py-1"
        >
          <span class="tw-text-orange-500 tw-font-semibold"
            >Service temporarily unavailable</span
          >
        </div>
        <div
          v-if="!companyCalendar.sync_enabled"
          class="tw-flex tw-items-center"
        >
          <div
            class="tw-inline-flex tw-bg-red-200 tw-rounded-full tw-text-center tw-px-5 tw-py-1"
          >
            <span class="tw-text-red-500 tw-font-semibold"
              >Connection error</span
            >
          </div>
          <div
            v-if="!externalCalendarConnection.is_active"
            class="tw-inline-flex tw-px-5 tw-py-1"
          >
            <a
              title="Fix the connection error"
              class="btn-link tw-text-blue-500 tw-font-semibold"
              @click="$emit('reconnect', externalCalendarConnection)"
              >Reconnect</a
            >
          </div>
        </div>
      </template>
    </td>
    <td style="width: 100px;">
      <div class="tw-flex tw-items-center tw-justify-center">
        <button
          class="btn btn-icon tw-border tw-border-gray-400 hover:tw-bg-gray-300 tw-ml-3 tw-flex tw-items-center tw-justify-center"
          :title="
            companyCalendar.sync_enabled
              ? 'Edit'
              : 'Please reconnect the company calendar before editing or deleting it, as we need permission to update the old entries.'
          "
          :disabled="!companyCalendar.sync_enabled"
          type="button"
          :style="
            companyCalendar.sync_enabled
              ? ''
              : 'pointer-events: auto; cursor: default'
          "
          @click.stop="$emit('edit-calendar')"
        >
          <SvgIcon name="edit-pencil" class="svg-icon tw-text-gray-700" />
        </button>
        <button
          class="btn btn-icon tw-border tw-bg-red-500 hover:tw-bg-red-500 tw-border-red-500 tw-ml-3 tw-flex tw-items-center tw-justify-center"
          :title="'Delete'"
          type="button"
          @click="$emit('delete-calendar')"
        >
          <SvgIcon name="trash" class="svg-icon tw-w-3 tw-h-3 tw-text-white" />
        </button>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'CompanyCalendarTableRow',

  props: {
    companyCalendar: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isSelfOwnedConnection() {
      return (
        this.externalCalendarConnection.owner_id === this.activeEmployment.id
      )
    },

    externalCalendarConnection() {
      return this.companyCalendar.external_calendar_connection
    },

    targetDisplay() {
      if (!this.companyCalendar.shared_mailbox_id) {
        return 'Personal'
      }
      const email = this.companyCalendar.sharedMailboxEmail
      return email ? `Shared (${email})` : 'Shared Mailbox'
    },
  },
}
</script>
